import { createFileRoute } from '@tanstack/react-router'

import { NotFoundState } from '@/components/common/NotFoundState'

/**
 * Every address under the shell that matches no page.
 *
 * A splat, because a pathless layout is never matched by a path none of its
 * children match — so its `notFoundComponent` alone would leave the root's,
 * outside the shell, to answer. Here the sidebar stays, and the way back is
 * where it always is.
 */
export const Route = createFileRoute('/_app/$')({
  component: NotFoundRoute,
})

function NotFoundRoute() {
  return <NotFoundState />
}
